import React from "react";

const UserSelect = ({ users, selected, onChange }) => (
  <div className="field">
    <label htmlFor="ma-user-select">Select user</label>
    <select
      id="ma-user-select"
      className="text-input"
      style={{ width: "100%", maxWidth: 340 }}
      value={selected}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">— Select a user —</option>
      {users.map((user) => (
        <option key={user.user_id} value={user.user_id}>
          {user.name || user.email}
        </option>
      ))}
    </select>
  </div>
);

export default UserSelect;
